<template>
    <section id="header" class="shadow-lg" :class="{ 'scrolled': !isAtTop  }">
      <nav class="navbar navbar-expand-lg navbar-dark" style="margin: 0; padding: 0;">
        <router-link class="navbarBrand" to="/">
          <img src="@/assets/LumabitLogoWhite.png" class="lumabitlogo" alt="LumaBIT Logo" />
        </router-link>

        <button id="flyoutButton"
          class="navbar-toggler d-flex d-lg-none flex-column justify-content-around" type="button" @click="toggleMenu"
          aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation"
          :class="{ collapsed: !showMenu }">
          <span class="toggler-icon top-bar" id="topToggle"></span>
          <span class="toggler-icon middle-bar" id="midToggle"></span>
          <span class="toggler-icon bottom-bar" id="botToggle"></span>
        </button>
        <header-phone v-if="!showDesktop" :showMenu="showMenu" @update:showMenu="toggleMenu()"
          id="phone-version"></header-phone>
        <header-desktop v-else id="desktop-version"></header-desktop>
      </nav>
    </section>
    <base-top></base-top>
</template>


<script>
import HeaderDesktop from '@/components/outsource/HeaderDesktop.vue';
import HeaderPhone from '@/components/outsource/HeaderPhone.vue';
import BaseTop from '../components/baseElems/BaseTop.vue';
export default {
  components: { HeaderDesktop, HeaderPhone, BaseTop },
  data() {
    return {
      showMenu: false,
      isAtTop: true,
      showDesktop: null,
    };
  },
  watch: {
    showMenu: function (value) { value ? document.body.style.overflow = "hidden" : document.body.style.overflow = "auto"; },
  },
  methods: {
    changeLook(){
      if(window.innerWidth <= 992){
        this.showDesktop = false;
      }else{
        this.showDesktop = true;
      }
    },
    toggleMenu() {
      this.showMenu = !this.showMenu; // Update the local data property
      window.scrollTo({ top: 0, behavior: 'smooth' })
    },
    handleScroll() { (window.scrollY > 0) ? this.isAtTop = false : this.isAtTop = true;}
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
    window.addEventListener("resize", this.changeLook);
    this.changeLook();
  }
};
</script>

<style scoped>
.scrolled {
  padding: 2px;
  margin: 0;
}

section {
  padding: 20px 1% 20px 20px;
  background-image: linear-gradient(to right, #6f42c1, #e83e8c);
  transition: all .3s;
}
.lumabitlogo {
  height: 54px;
  width: 196px;
}

.navbarBrand {
  font-size: 1.5rem;
  margin: 0px 0px 0px 5%;
  transition: 0.3s ease-out;
}

.navbarBrand:hover {
  transform: scale(1.1);
}

/* hamburger menu */
.navbar-toggler {
  margin-right: 18px;
}

.navbar-toggler {
  width: 20px;
  height: 10px;
  position: relative;
  transition: 0.5s ease-in-out;
}

.navbar-toggler,
.navbar-toggler:focus,
.navbar-toggler:active,
.navbar-toggler-icon:focus {
  outline: none;
  box-shadow: none;
  border: 0;
}

.navbar-toggler span {
  margin: 0;
  padding: 0;
}

.toggler-icon {
  display: block;
  position: absolute;
  height: 2px;
  width: 100%;
  background: #f8f9fa;
  ;
  border-radius: 1px;
  opacity: 1;
  left: 0;
  transform: rotate(0deg);
  transition: 0.25s ease-in-out;
}

.middle-bar {
  margin-top: 0px;
  width: 16px;
}

.navbar-toggler .top-bar {
  margin-top: 0px;
  transform: rotate(135deg);
}

.navbar-toggler .middle-bar {
  opacity: 0;
  filter: alpha(opacity=0);
}

.navbar-toggler .bottom-bar {
  margin-top: 0px;
  transform: rotate(-135deg);
}

.navbar-toggler.collapsed .top-bar {
  margin-top: -14px;
  transform: rotate(0deg);
}

.navbar-toggler.collapsed .middle-bar {
  opacity: 1;
  filter: alpha(opacity=100);
}

.navbar-toggler.collapsed .bottom-bar {
  margin-top: 14px;
  transform: rotate(0deg);
}
</style>

<style>
.btn {
  padding: 6px;
}

.navbar-nav {
  margin-left: auto;
}

.stroke ul {
  list-style: none;
  text-align: center;
}

.stroke ul li {
  display: inline-block;
}

.stroke ul li a {
  display: block;
  text-decoration: none;
  color: #fdfdff;
  font-weight: 600;
  text-transform: uppercase;
}

.stroke ul li a,
.stroke ul li a:focus,
.stroke ul li a:after,
.stroke ul li a:before {
  transition: all 0.5s;
  color: #fdfdff
}

.stroke ul li a:hover {
  transform: scale(1.1);
  color: #fdfdff;
}

/* stroke */
.stroke ul li a,
.stroke ul li a {
  position: relative;
}

.stroke ul li a:after,
.stroke ul li a:after {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 0%;
  content: ".";
  color: transparent;
  background: #fdfdff;
  height: 1px;
  transform: translateY(1px);
}

.stroke ul li a:hover:after {
  width: 100%;
}

.nav-link {
  margin: 0px 4px;
  padding: 4px;
}

.stroke ul li,
.nav-link,
.nav-link:active {
  border: none;
  color: #fdfdff;
}

.router-link-exact-active {
  border-radius: 0%;
  color: #ffffff;
  border-bottom: 1px solid #fdfdff;
}
</style>